import React from "react";
import JssProvider from "react-jss/lib/JssProvider";
import { createGenerateClassName } from "@material-ui/core/styles";

// Material UI v3's different module builds can have separate default counters.
// Share one generator across the whole app, including dialogs and portals.
// Create it outside render so re-renders cannot reset the counter.
const generateClassName = createGenerateClassName({ productionPrefix: "hg" });

export default function AppStylesProvider({ children }) {
    return (
        <JssProvider generateClassName={generateClassName}>
            {children}
        </JssProvider>
    );
}